// extracted by mini-css-extract-plugin
export default {"loginButtons":"login_loginButtons__RBuY5"};